import {
	saveLoF,
	saveLoFResolved,
	saveLoFRejected,
	getLoFInspectionFields,
	getLoFFields,
	getLoFFieldsRejected,
	getLoFFieldsResolved,
	getLoFInspectionFieldsRejected,
	getLoFInspectionFieldsResolved,
} from '@Actions';
import { error, success } from '@innovyze/stylovyze';
import { put, retry, select, takeLatest } from '@redux-saga/core/effects';
import { LoFStoreSelector, RiskConfigSelector } from '@Selectors';
import {
	getLoFFieldsApi,
	getLoFInspectionFieldsApi,
} from '@Services/LoF/LoF.services';
import { Category, LoFStoreState, RiskConfig } from '@Types';
import axios, { AxiosError, AxiosResponse } from 'axios';
import { mapSnowCfgToMongoCfg } from './Risk.sagas';
import { saveRiskConfigApi } from '@Services/Risk/Risk.services';
import { t } from 'i18next';
import { AnyAction } from 'redux';

function* getLoFInspectionFieldsSaga(action: AnyAction) {
	try {
		const response: AxiosResponse<Category[]> = yield retry(
			5,
			1500,
			getLoFInspectionFieldsApi,
			action.payload,
		);
		yield put(getLoFInspectionFieldsResolved(response.data));
	} catch (e) {
		yield put(getLoFInspectionFieldsRejected());
	}
}
function* getLoFFieldsSaga(action: AnyAction) {
	try {
		const response: AxiosResponse<Category[]> = yield retry(
			5,
			1500,
			getLoFFieldsApi,
			action.payload,
		);
		yield put(getLoFFieldsResolved(response.data));
	} catch (e) {
		yield put(getLoFFieldsRejected());
	}
}
function* watchGetLoFConfig() {
	yield takeLatest(getLoFInspectionFields, getLoFInspectionFieldsSaga);
	yield takeLatest(getLoFFields, getLoFFieldsSaga);
}

function* saveRiskConfigSaga(action: AnyAction) {
	try {
		const riskConfig: RiskConfig = yield select(RiskConfigSelector);
		const lofConfig: LoFStoreState = yield select(LoFStoreSelector);
		const finalRiskConfig: RiskConfig = {
			...riskConfig,
			LOFCategories: lofConfig.categories,
		};

		const mongoRiskConfig = mapSnowCfgToMongoCfg(finalRiskConfig);

		yield retry(5, 1500, saveRiskConfigApi, mongoRiskConfig);

		yield put(saveLoFResolved());
		yield put(success(t('LoF configuration saved')));
		action.payload.refresh();
	} catch (e) {
		yield put(saveLoFRejected());
		let info = t('No additional information');
		if (axios.isAxiosError(e)) {
			const axiosError = e as AxiosError;
			info = axiosError.response?.statusText ?? info;
		}
		yield put(
			error(
				t('LoF configuration failed to save: {{info}}', {
					info: info,
				}),
			),
		);
	}
}
function* watchSaveLoF() {
	yield takeLatest(saveLoF, saveRiskConfigSaga);
}

const sagaArray = [watchGetLoFConfig(), watchSaveLoF()];

export default sagaArray;
